import auth from 'redux/slices/auth/selectors';
import profile from 'redux/slices/profile/selectors';
import outlet from 'redux/slices/outlet/selectors';

export default {
    auth,
    profile,
    outlet,
};
